/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Avatar, Button } from "antd";

//import CSS
import "./MessageHeaderComponent.css";

const MessageHeaderComponent = ({
  avatarUrl,
  title,
  subTitle,
  onGoToCaseClick,
}) => {
  return (
    <div className="message-header-wrapper">
      <div>
        {avatarUrl && (
            <div className="message-header-section-wrapper .message-header-avatar">
                <Avatar size={56} src={avatarUrl} />
            </div>
        )}
        <div className="message-header-section-wrapper message-header-title-wrapper">
          <div className="message-header-subtitle">{subTitle}</div>
          <div className="message-header-title">{title}</div>
        </div>
      </div>
      {onGoToCaseClick && (
        <Button className='message-case-details-btn' type='primary' onClick={onGoToCaseClick}>Go to case</Button>
      )}
    </div>
  );
};

export default MessageHeaderComponent;
